import API from "./axios";

export const getEvent = (room_id, id) => {
  return API.get(`/rooms/${room_id}/events/${id}/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("api_token")}`,
    },
  });
};
